





























































































































































































































































import {Vue, Component} from 'vue-property-decorator';
import CompSelectBox from '@/components/common/CompSelectBox.vue';
import countrys from '@/const/words/country';
import {popupResize} from '@/utils/ncp';
import {ncpPopup} from '@/utils/ncp';
import {GetDeliveryTemplateGroup, DeliveryCompany} from 'supporter';
import {ProcessedAddress} from '@/types/manage';
@Component({
  components: {
    CompSelectBox
  }
})
export default class DeliveryTemplateAddForm extends Vue {
  private groups: GetDeliveryTemplateGroup[] = [];
  private releaseWarehouses: any[] = [];
  private returnWarehouses: any[] = [];
  private deliveryCompanyTypes: DeliveryCompany[] = [];
  private returnWarehouseNew = false;
  private releaseWarehouseNew = false;
  private countrys = countrys;
  private returnDeliveryAmtGuide = false;
  private partnerNo = 0;
  private data: any = {
    returnWarehouseNo: 0,
    templateGroupNo: 0,
    releaseWarehouseNo: 0,
    name: '',
    deliveryType: 'PARCEL_DELIVERY',
    deliveryCompanyType: '',
    default: false,
    deliveryFee: {
      deliveryConditionType: '',
      returnDeliveryAmt: '',
      criteria: '',
      deliveryAmt: ''
    },
    releaseWarehouseRequest: {
      usesSubstitutionText: false,
      address: {
        zipCd: '',
        detailAddress: '',
        address: '',
        countryCd: 'KR',
        overseaRegion: '',
        overseaCity: '',
        overseaAddress2: '',
        overseaAddress1: ''
      },
      name: '',
      substitutionText: ''
    },
    returnWarehouseRequest: {
      usesSubstitutionText: false,
      address: {
        zipCd: '',
        detailAddress: '',
        address: '',
        countryCd: 'KR',
        overseaRegion: '',
        overseaCity: '',
        overseaAddress2: '',
        overseaAddress1: ''
      },
      name: '',
      substitutionText: ''
    }
  };
  get groupSummary() {
    if (this.groups.length) {
      const finded = this.groups.find((group) => group.templateGroupNo === this.data.templateGroupNo);
      return finded ? finded.summary : this.groups[0].summary;
    }
    return '';
  }
  created() {
    const partnerNo = this.$route.query.partnerNo as string;
    this.partnerNo = Number(partnerNo);
    this.$api.getDeliveryTemplateGroups({params: {partnerNo}}).then((res) => {
      this.groups = res.data;
      if (this.groups.length) {
        const group = this.groups[0];
        this.data.templateGroupNo = group.templateGroupNo;
        const defaultReturnWarehouse = group.templates.find((template) => template.returnWarehouse.defaultReturnWarehouse);
        const defaultReleaseWarehouse = group.templates.find((template) => template.releaseWarehouse.defaultReleaseWarehouse);
        this.data.returnWarehouseNo = defaultReturnWarehouse ? defaultReturnWarehouse.returnWarehouse.warehouseNo : 0;
        this.data.releaseWarehouseNo = defaultReleaseWarehouse ? defaultReleaseWarehouse.releaseWarehouse.warehouseNo : 0;
      }
    });
    this.$api.getWarehouses({params: {partnerNo: this.partnerNo}}).then((res) => {
      this.releaseWarehouses = [{warehouseNo: 0, summary: this.$t('DELIVERY_GROUP_TEMPLATE_RELEASE_WAREHOUSE_SELECT')}, ...res.data as any];
      this.returnWarehouses = [{warehouseNo: 0, summary: this.$t('DELIVERY_GROUP_TEMPLATE_RETURN_WAREHOUSE_SELECT')}, ...res.data  as any];
      this.releaseWarehouses.forEach(e => {
        if(e.defaultReleaseWarehouse){
          this.data.releaseWarehouseNo = e.warehouseNo
        }
      });
     this.returnWarehouses.forEach(e => {
        if(e.defaultReturnWarehouse){
          this.data.returnWarehouseNo = e.warehouseNo
        }
      });
    });
    this.$api.getDeliveryCompanies({params: {countryCd: 'KR'}}).then((ret) => {
      if (ret && ret.data) {
        this.deliveryCompanyTypes = [{deliveryCompanyType: '', label: this.$t('DELIVERY_GROUP_TEMPLATE_DELIVERY_COMPANY') as string}, ...ret.data];
      }
    });
  }
  deliveryTypeChanged() {
    this.data.deliveryCompanyType = '';
  }
  private async mounted() {
    this.$nextTick(() => {
      popupResize(1052, 592);
    });
  }

  returnWarehouseChanged() {
    this.returnWarehouseNew = false;
    this.data.returnWarehouseRequest = {
      usesSubstitutionText: false,
      address: {
        zipCd: '',
        detailAddress: '',
        address: '',
        countryCd: 'KR',
        overseaRegion: '',
        overseaCity: '',
        overseaAddress2: '',
        overseaAddress1: ''
      },
      name: '',
      substitutionText: ''
    };
  }
  releaseWarehouseChanged() {
    this.releaseWarehouseNew = false;
    this.data.releaseWarehouseRequest = {
      usesSubstitutionText: false,
      address: {
        zipCd: '',
        detailAddress: '',
        address: '',
        countryCd: 'KR',
        overseaRegion: '',
        overseaCity: '',
        overseaAddress2: '',
        overseaAddress1: ''
      },
      name: '',
      substitutionText: ''
    };
  }
  setAddress(address: ProcessedAddress, warehouseName: string) {
    if(address.isJibunSelected){
      this.data[warehouseName].address.address = address.jibunAddress;
    }else {
      this.data[warehouseName].address.address = address.roadAddress;
      this.data[warehouseName].address.detailAddress = address.roadAddressExtra;
    }
    this.data[warehouseName].address.zipCd = address.zipCode;
    this.warehouseName = '';
  }
  callback(address: ProcessedAddress) {
    (window as any).addressCallback = undefined;
    if (this.warehouseName) {
      this.setAddress(address, this.warehouseName);
    }
  }
  private warehouseName = '';
  goSelectAddress(warehouseName: string) {
    this.warehouseName = warehouseName;
    (window as any).addressCallback = this.callback;
    ncpPopup('/address/search/popup?dataCallback=addressCallback', this.$t('DELIVERY_GROUP_TEMPLATE_WAREHOUSE_ADD_POSTAL_CODE'), 550, 880);
  }
  close() {
    if(confirm(this.$t('DELIVERY_GROUP_TEMPLATE_CONFIRM_CANCEL') as string)){
      window.close();
    }
  }
  save() {
    if (this.validationTemplate()) {
      const template = this.getTemplate();

      this.$api.postDeliveryTemplates({data: template}).then((res: any) => {
        window.opener.postMessage({templateNo: res.data.templateNo});
        alert(this.$t('PRODUCT_OPTION_TIP_SAVED'))
        window.close();
      });
    }
  }
  getTemplate() {
    let template: any = {
      templateGroupNo: this.data.templateGroupNo,
      partnerNo: this.partnerNo,
      default: this.data.default,
      name: this.data.name,
      deliveryType: this.data.deliveryType,
      deliveryCompanyType: this.data.deliveryCompanyType ? this.data.deliveryCompanyType : undefined,
      deliveryFee: {
        deliveryConditionType: this.data.deliveryFee.deliveryConditionType,
        returnDeliveryAmt: this.data.deliveryFee.returnDeliveryAmt
      }
    };
    // 배송비 유형에 따라
    if (this.data.deliveryFee.deliveryConditionType === 'FIXED_FEE') {
      template.deliveryFee.deliveryAmt = this.data.deliveryFee.deliveryAmt;
    }
    if (this.data.deliveryFee.deliveryConditionType === 'CONDITIONAL') {
      template.deliveryFee.deliveryAmt = this.data.deliveryFee.deliveryAmt;
      template.deliveryFee.criteria = this.data.deliveryFee.criteria;
    }
    if (this.releaseWarehouseNew) {
      if (this.data.releaseWarehouseRequest.usesSubstitutionText) {
        template.releaseWarehouseRequest = {
          usesSubstitutionText: true,
          name: this.data.releaseWarehouseRequest.name,
          substitutionText: this.data.releaseWarehouseRequest.substitutionText
        };
      } else {
        if (this.data.releaseWarehouseRequest.address.countryCd === 'KR') {
          template.releaseWarehouseRequest = {
            name: this.data.releaseWarehouseRequest.name,
            address: {
              countryCd: this.data.releaseWarehouseRequest.address.countryCd,
              address: this.data.releaseWarehouseRequest.address.address,
              zipCd: this.data.releaseWarehouseRequest.address.zipCd,
              detailAddress: this.data.releaseWarehouseRequest.address.detailAddress
            }
          };
        } else {
          template.releaseWarehouseRequest = {
            name: this.data.releaseWarehouseRequest.name,
            address: {
              countryCd: this.data.releaseWarehouseRequest.address.countryCd,
              zipCd: this.data.releaseWarehouseRequest.address.zipCd,
              overseaAddress1: this.data.releaseWarehouseRequest.address.overseaAddress1,
              overseaAddress2: this.data.releaseWarehouseRequest.address.overseaAddress2,
              overseaCity: this.data.releaseWarehouseRequest.address.overseaCity,
              overseaRegion: this.data.releaseWarehouseRequest.address.overseaRegion
            }
          };
        }
      }
    } else {
      template.releaseWarehouseNo = this.data.releaseWarehouseNo;
    }

    if (this.returnWarehouseNew) {
      if (this.data.returnWarehouseRequest.usesSubstitutionText) {
        template.returnWarehouseRequest = {
          usesSubstitutionText: true,
          name: this.data.returnWarehouseRequest.name,
          substitutionText: this.data.returnWarehouseRequest.substitutionText
        };
      } else {
        if (this.data.returnWarehouseRequest.address.countryCd === 'KR') {
          template.returnWarehouseRequest = {
            name: this.data.returnWarehouseRequest.name,
            address: {
              countryCd: this.data.returnWarehouseRequest.address.countryCd,
              address: this.data.returnWarehouseRequest.address.address,
              zipCd: this.data.returnWarehouseRequest.address.zipCd,
              detailAddress: this.data.returnWarehouseRequest.address.detailAddress
            }
          };
        } else {
          template.returnWarehouseRequest = {
            name: this.data.returnWarehouseRequest.name,
            address: {
              countryCd: this.data.returnWarehouseRequest.address.countryCd,
              zipCd: this.data.returnWarehouseRequest.address.zipCd,
              overseaAddress1: this.data.returnWarehouseRequest.address.overseaAddress1,
              overseaAddress2: this.data.returnWarehouseRequest.address.overseaAddress2,
              overseaCity: this.data.returnWarehouseRequest.address.overseaCity,
              overseaRegion: this.data.returnWarehouseRequest.address.overseaRegion
            }
          };
        }
      }
    } else {
      template.returnWarehouseNo = this.data.returnWarehouseNo;
    }
    return template;
  }
  validationTemplate() {
    if (!this.data.name) {
      alert(this.$t('DELIVERY_GROUP_TEMPLATE_MESSAGE1'));
      return false;
    }
    if (!this.data.deliveryFee.deliveryConditionType) {
      alert(this.$t('DELIVERY_GROUP_TEMPLATE_MESSAGE2'));
      return false;
    }
    if (this.data.deliveryFee.deliveryConditionType === 'FIXED_FEE') {
      if (!this.data.deliveryFee.deliveryAmt) {
        alert(this.$t('DELIVERY_GROUP_TEMPLATE_MESSAGE3'));
        return false;
      }
      if (!$.isNumeric(this.data.deliveryFee.deliveryAmt)) {
        alert(this.$t('DELIVERY_GROUP_TEMPLATE_AREAFEE_ADD_MESSAGE4'));
        return false;
      }
    }
    if (this.data.deliveryFee.deliveryConditionType === 'CONDITIONAL') {
      if (!this.data.deliveryFee.deliveryAmt || !this.data.deliveryFee.criteria) {
        alert(this.$t('DELIVERY_GROUP_TEMPLATE_MESSAGE3'));
        return false;
      }
      if (!$.isNumeric(this.data.deliveryFee.deliveryAmt) || !$.isNumeric(this.data.deliveryFee.criteria)) {
        alert(this.$t('DELIVERY_GROUP_TEMPLATE_AREAFEE_ADD_MESSAGE4'));
        return false;
      }
    }
    if (this.releaseWarehouseNew) {
      if (!this.data.releaseWarehouseRequest.name) {
        alert(this.$t('DELIVERY_GROUP_TEMPLATE_MESSAGE7'));
        return false;
      }
      if (this.data.releaseWarehouseRequest.usesSubstitutionText) {
        if (!this.data.releaseWarehouseRequest.substitutionText) {
          alert(this.$t('DELIVERY_GROUP_TEMPLATE_MESSAGE8'));
          return false;
        }
      } else {
        if (this.data.releaseWarehouseRequest.address.countryCd === 'KR') {
          if (!this.data.releaseWarehouseRequest.address.address || !this.data.releaseWarehouseRequest.address.zipCd || !this.data.releaseWarehouseRequest.address.detailAddress) {
            alert(this.$t('DELIVERY_GROUP_TEMPLATE_MESSAGE9'));
            return false;
          }
        } else {
          if (!this.data.releaseWarehouseRequest.address.overseaAddress1) {
            alert(this.$t('DELIVERY_GROUP_TEMPLATE_MESSAGE10'));
            return false;
          }
          if (!this.data.releaseWarehouseRequest.address.overseaAddress2) {
            alert(this.$t('DELIVERY_GROUP_TEMPLATE_MESSAGE11'));
            return false;
          }
          if (!this.data.releaseWarehouseRequest.address.overseaCity) {
            alert(this.$t('DELIVERY_GROUP_TEMPLATE_MESSAGE12'));
            return false;
          }
          if (!this.data.releaseWarehouseRequest.address.overseaRegion) {
            alert(this.$t('DELIVERY_GROUP_TEMPLATE_MESSAGE13'));
            return false;
          }
          if (!this.data.releaseWarehouseRequest.address.zipCd) {
            alert(this.$t('DELIVERY_GROUP_TEMPLATE_MESSAGE14'));
            return false;
          }
        }
      }
    } else {
      if (!this.data.releaseWarehouseNo) {
        alert(this.$t('DELIVERY_GROUP_TEMPLATE_MESSAGE4'));
        return false;
      }
    }
    if (this.returnWarehouseNew) {
      if (!this.data.returnWarehouseRequest.name) {
        alert(this.$t('DELIVERY_GROUP_TEMPLATE_MESSAGE7'));
        return false;
      }
      if (this.data.returnWarehouseRequest.usesSubstitutionText) {
        if (!this.data.returnWarehouseRequest.substitutionText) {
          alert(this.$t('DELIVERY_GROUP_TEMPLATE_MESSAGE8'));
          return false;
        }
      } else {
        if (this.data.returnWarehouseRequest.address.countryCd === 'KR') {
          if (!this.data.returnWarehouseRequest.address.address || !this.data.returnWarehouseRequest.address.zipCd || !this.data.returnWarehouseRequest.address.detailAddress) {
            alert(this.$t('DELIVERY_GROUP_TEMPLATE_MESSAGE9'));
            return false;
          }
        } else {
          if (!this.data.returnWarehouseRequest.address.overseaAddress1) {
            alert(this.$t('DELIVERY_GROUP_TEMPLATE_MESSAGE10'));
            return false;
          }
          if (!this.data.returnWarehouseRequest.address.overseaAddress2) {
            alert(this.$t('DELIVERY_GROUP_TEMPLATE_MESSAGE11'));
            return false;
          }
          if (!this.data.returnWarehouseRequest.address.overseaCity) {
            alert(this.$t('DELIVERY_GROUP_TEMPLATE_MESSAGE12'));
            return false;
          }
          if (!this.data.returnWarehouseRequest.address.overseaRegion) {
            alert(this.$t('DELIVERY_GROUP_TEMPLATE_MESSAGE13'));
            return false;
          }
          if (!this.data.returnWarehouseRequest.address.zipCd) {
            alert(this.$t('DELIVERY_GROUP_TEMPLATE_MESSAGE14'));
            return false;
          }
        }
      }
    } else {
      if (!this.data.returnWarehouseNo) {
        alert(this.$t('DELIVERY_GROUP_TEMPLATE_MESSAGE5'));
        return false;
      }
    }
    if (!this.data.deliveryFee.returnDeliveryAmt) {
      alert(this.$t('DELIVERY_GROUP_TEMPLATE_MESSAGE6'));
      return false;
    }
    if (!$.isNumeric(this.data.deliveryFee.returnDeliveryAmt)) {
      alert(this.$t('DELIVERY_GROUP_TEMPLATE_AREAFEE_ADD_MESSAGE4'));
      return false;
    }
    return true;
  }
  checkNumber(e: Event, type: string) {
    let value: any = (e.target as HTMLInputElement).value;
    if (!value.match(/[^\d]/g)) {
      return;
    } else {
      value = Number(value.replace(/[^\d]/g, ''));
    }
    switch (type) {
      case 'returnDeliveryAmt':
        this.data.deliveryFee.returnDeliveryAmt = value;
        break;
      case 'criteria':
        this.data.deliveryFee.criteria = value;
        break;
      case 'deliveryAmt':
        this.data.deliveryFee.deliveryAmt = value;
        break;
      default:
        break;
    }
  }
}
